import React from 'react';
import MetsIcon from '../MetsIcon';
import classnames from 'classnames';

export interface OnChipClick {
    (item: ChipListItem, event: React.MouseEvent): void
}

export interface ChipListItem {
    disabled: boolean,
    label: string,
    value: string
}

export interface ChipListProps {
    className?: string,
    id?: string,
    items: ChipListItem[],
    onChipClick?: OnChipClick
}

function ChipList(props: ChipListProps) {
    
    const widgetClassName = classnames("chip-list", props.className);

    return (

        <div className={widgetClassName} id={props.id} data-testid={props.id}>
            {props.items.map((item: ChipListItem, index) => {
                const chipClassName = classnames("chip", { "disabled": item.disabled });
                return (
                    <div className={chipClassName} key={index} onClick={(event) => { if (props.onChipClick) { props.onChipClick(item, event); }}} data-value={item.value} data-testid={props.id + 'Item' + index}>
                        <span className="label">{item.label}</span>
                        <MetsIcon className="xIcon" name="svg_xIcon" />
                    </div>
                );
            })}
        </div>

    );

}

ChipList.defaultProps = {
    id: "chipList"
};

export default ChipList;